module.exports = __webpack_public_path__ + "mobile/img/hot-img4.286e16f5.png";